import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { TeamGrouped } from '../types';

export function useTeamMembers(): {
  data: TeamGrouped | undefined;
  isLoading: boolean;
} {
  const query = useQuery({
    queryKey: ['team', 'members'],
    queryFn: (): Promise<TeamGrouped> =>
      pb.send('/api/team/members', { method: 'GET' }),
    staleTime: 60_000,
  });
  return { data: query.data, isLoading: query.isLoading };
}
